import ds from './designSystem'

export const antdTheme = {
  token: {
    colorPrimary: ds.get('colors.electricBlue'),
    fontFamily: 'InterUI, system, sans-serif',
    fontSizeHeading1: ds.get('type.sizes.headings.level1'),
    fontSizeHeading2: ds.get('type.sizes.headings.level2'),
    fontSizeHeading3: ds.get('type.sizes.headings.level3'),
    fontSizeHeading4: ds.get('type.sizes.headings.level4'),
    colorTextDescription: ds.get('colors.greyDarker'),
  },
}
